import { render } from "./LogsTable.vue?vue&type=template&id=bf117400&scoped=true"
import script from "./LogsTable.vue?vue&type=script&lang=js"
export * from "./LogsTable.vue?vue&type=script&lang=js"

import "./LogsTable.vue?vue&type=style&index=0&id=bf117400&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bf117400"

export default script